import {
  Image,
  WidgetHeader,
  WidgetHeaderContent,
  WidgetHeaderTicker,
} from '@frontend/ui-library';
import WidgetHeaderCountdownBar from '../WidgetHeaderCountdownBar/WidgetHeaderCountdownBar';
import WidgetHeaderRateTimer from '../WidgetHeaderRateTimer/WidgetHeaderRateTimer';
import { isOfframpBill } from '../../utils';

interface PaymentPageWidgetHeaderProps {
  paymentExpiresAt?: number;
  paymentStartedAt?: number;
  exchangeRate?: number;
  fiatCurrency?: string;
  cryptoCurrency?: string;
  tickerImageSrc?: string;
  billType: string;
}

export default function PaymentPageWidgetHeader({
  paymentExpiresAt,
  paymentStartedAt,
  exchangeRate,
  fiatCurrency,
  cryptoCurrency,
  tickerImageSrc,
  billType,
}: PaymentPageWidgetHeaderProps): JSX.Element {
  const showLoadingHeader =
    !exchangeRate || !fiatCurrency || !cryptoCurrency || !tickerImageSrc;

  const isOffRamp = isOfframpBill(billType);

  return (
    <WidgetHeader
      countdownBar={
        paymentExpiresAt &&
        paymentStartedAt && (
          <WidgetHeaderCountdownBar
            expiresAt={paymentExpiresAt}
            startedAt={paymentStartedAt}
          />
        )
      }
    >
      <WidgetHeaderContent
        loading={showLoadingHeader}
        title={
          showLoadingHeader ? (
            `Waiting for ${isOffRamp ? 'transaction' : 'payment'}`
          ) : (
            <WidgetHeaderTicker
              ticker={<Image src={tickerImageSrc} alt={cryptoCurrency} />}
              value={`${exchangeRate} ${fiatCurrency.toUpperCase()}`}
              tooltipContent={`${cryptoCurrency.toUpperCase()} to ${fiatCurrency.toUpperCase()} conversion rate`}
            />
          )
        }
        rightSlot={
          !showLoadingHeader && (
            <WidgetHeaderRateTimer expiresAt={paymentExpiresAt || 0} />
          )
        }
      />
    </WidgetHeader>
  );
}
